import en from './en.json'
import zhHans from './zh-Hans.json'
import zhHant from './zh-Hant.json'
import ja from './ja.json'
export default {
	en,
	'zh-Hans': zhHans,
	'zh-Hant': zhHant,
	ja
}
